export default __webpack_public_path__ + "static/water-2803b9402374d1119eb5b1d39f07c03a.mp4";